export enum SyncMainUnitData {
  Basic,
  Details,
  Gallery,
  Instructions,
  CustomInfo,
  Location,
  RateSettings,
  Taxes,
  Fees,
  PaymentSchedules,
  UserRestrictions,
}
